<template>
    <div class="wrapper-support">
        <b-container class="contentcontainer">
            <b-row class="contentcontainer__head">
              <h2>EU GDPR</h2>
            </b-row>
            <hr/>
            <b-row>
                <b-col>
                  <p><strong>BackupMonkey is fully EU GDPR compliant! We are aware of all legal requirements and comply with them.</strong></p>
                  <p>The security of your own and your clients data is our primary objective and we are taking all possible measures to protect your data at all times.</p>
                  <p>BackupMonkey does not persistently save or audit any data from the connected sites. "Processing" of data of connected sites is strictly limited to the sort of processing that is required for our service, i.e. restoring a database backup of a site in order to test the full functionality of a website backup. </p>
                  <p>If you have any further questions about how we handle data, feel free to reach out to us a <a href="mailto:hello@backupmonkey.io">hello@backupmonkey.io</a></p>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="contentcontainer">
          <b-row class="contentcontainer__head">
            <h2>Data Processing Agreement</h2>
          </b-row>
          <hr/>
          <b-row>
            <b-col>
                <p>Because BackupMonkey technically is processing user-related data (see above) it might be necessary for you to establish a so called Data Processing Agreement (DPA) with us. We provide such an agreement for you, <a href="/docs/DPA.pdf">click here to download</a> it.</p>
                <p>Once you have downloaded the document, please add your company details, sign it and send the signed document to <a href="mailto:hello@backupmonkey.io" target="_blank">hello@backupmonkey.io</a>. We will sign it too and send you a signed version back.</p>
            </b-col>
          </b-row>
        </b-container>
      <b-container class="contentcontainer">
        <b-row class="contentcontainer__head">
          <h2>Policy Notes for your Clients</h2>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <p>Please note, BackupMonkey might be specified in your customer's privacy policy.
              Our partner for this: easyRechtssicher. With multiple CMS plugins, the websites of your
              Customers are automatically updated when there are legal changes.</p>
            <p>Moreover: Options for BackupMonkey, many other special Joomla services and great support. Become
              Member here: <a href="https://easyrechtssicher.de/produkte/mitgliedschaft-webdesigner-agenturen-2/" target="_blank">easyRechtssicher</a> </p>
            <p>If you still have questions, simply write directly to the founder, lawyer Dr. Ronald Kandelhard, at <a href="mailto:mail@easyRechtssicher.de.">mail@easyRechtssicher.de.</a> </p>
          </b-col>
        </b-row>
      </b-container>
        <b-container class="contentcontainer">
          <b-row class="contentcontainer__head">
            <h2>Subprocessors</h2>
          </b-row>
          <hr/>
          <b-row>
            <b-col>
                <p>BackupMonkey is currently using services of the following subprocessors:</p>
                <ul>
                    <li>Data Center: Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Germany, Contact: data-protection@hetzner.com.</li>
                    <li>Website- and Mailserver Hosting: hosting.de GmbH, Franzstr. 51, 52064 Aachen, Germany, Contact: info@hosting.de.</li>
                    <li>Credit Card Processing: Stripe, 510 Townsend Street, San Francisco, CA 94103, US</li>
                    <li>Amazon Simple Email Service (SES), Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxemburg</li>
                </ul>
            </b-col>
          </b-row>
      </b-container>
    </div>
</template>

<script>
export default {
  name: 'DpaInfo'
}
</script>
